module.exports = __webpack_public_path__ + "img/lg_ring_r_0_0_1@3x.e100a48f.png";